export default "__VITE_ASSET__BbB1GF0O__"